'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var ISBROWSER = typeof XMLHttpRequest !== 'undefined';
//根据浏览器域名决定请求哪个后端域名的接口
var INTERFACEHOST = {
  zhuanzhuan: 'https://app.zhuanzhuan.com',
  '58': 'https://zhuan.58.com'
};
var domain = 'zhuanzhuan';
if (ISBROWSER) {
  var hosts = location.host.match(/[^\.]*(?=.com)/);
  domain = hosts && hosts[0];
}
var baseURL = INTERFACEHOST[domain] ? INTERFACEHOST[domain] : 'https://app.zhuanzhuan.com'; //设置默认请求头部，如果开发环境下需要代理，需要把这里注释掉
exports.default = baseURL;